import styled from "styled-components";
import Image from "../../Image";
import Message from "./Message";
import {
  useTranslation,
  useCustomImage,
  useTexts,
  useAppSelector,
} from "../../../hooks";
import { doTranslation, formatCurrency } from "../../../utils";

const StyledSymbols = styled.div`
  .symbols-container {
    display: flex;
    justify-content: center;
  }

  .specials {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-width: 20%;

    .title {
      text-align: center;
    }

    .image {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;

      img {
        max-width: 100%;
      }
    }
  }

  .symbols {
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 40em;

    .symbol {
      height: 100%;
      justify-content: flex-end;
      flex-direction: column;
      .image {
        display: flex;
        padding: 0.7em;
        img {
          width: 100%;
          height: 100%;
          width: 100%;
          max-width: 8em;
          max-height: initial;
        }
      }
    }

    .symbols-row {
      width: 100%;
      justify-content: space-between;
    }
  }

  .specials > .pay,
  .symbol > .pay {
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.7em;
    line-height: 1.3em;
    background-size: 100% 100%;
    background-image: url(${(props: any) => props.paysBackground});

    p {
      padding: 0;
      margin: 0;
    }
  }

  .symbols,
  .symbols-row,
  .symbol,
  .symbol > .pay {
    display: flex;
    justify-content: center;
  }

  .symbols,
  .symbols-row,
  .symbol {
    align-items: center;
  }

  ${(props: any) => props.customStyle || ""}
` as any;

const SymbolsRow: React.FC<{ row: any[] }> = ({ row }) => {
  return (
    <div className="symbols-row">
      {row.map((symbol: any, i: any) => (
        <Symbol key={i} {...symbol} />
      ))}
    </div>
  );
};

const Symbol: React.FC<{
  id: number;
  pays: any;
  type: string;
}> = ({ id, pays, type }) => {
  const { currency, dynamicPaytable, stake } = useAppSelector((state) => {
    return { ...state.details, stake: state.selectors.stake.value };
  });
  const typeClass = type === "special" ? "specials" : "symbol";
  const { common, custom } = useTexts();
  const paysTable = Object.keys(pays)
    .sort((a, b) => parseInt(b) - parseInt(a))
    .map((k, i) => {
      const isNumber = parseInt(k).toString() === k;
      const pay = dynamicPaytable
        ? `${formatCurrency(pays[k] * stake, currency)}`
        : pays[k];
      const text = isNumber
        ? `x${k} = ${pay}`
        : // if the key in the pays table is not number  the value are directly
          // displayed, which gives the ability arbitrary text to be displayed
          // in the pays table
          `${doTranslation(pays[k], custom, common)}`;
      return <p key={i}>{text}</p>;
    });

  return (
    <div className={typeClass}>
      <div className="image">
        <Image src={`symbols/${id}.png`} />
      </div>

      <div className="pay">{paysTable}</div>
    </div>
  );
};

type SymbolsType = {
  data: any;
  message: any;
  paysBackground?: string;
  style?: any;
};

const Symbols: React.FC<SymbolsType> = ({
  data,
  message,
  paysBackground,
  style,
}) => {
  return (
    <StyledSymbols
      customStyle={style}
      paysBackground={useCustomImage(paysBackground)}
    >
      <div className="symbols-container">
        {data.spetial.map((symbol: any, i: number) => (
          <Symbol key={i} {...symbol} type="special" />
        ))}

        <div className="symbols">
          {data.main.map((row: any, i: number) => (
            <SymbolsRow key={i} row={row} />
          ))}
        </div>
      </div>

      <Message
        className="symbols-message"
        text={useTranslation(message?.text ?? "")}
        image={message.image}
      />
    </StyledSymbols>
  );
};

export default Symbols;
